export default __webpack_public_path__ + "static/media/nslogo.fe3c4409.jpeg";